/* eslint-disable */
/* eslint-disable no-inner-declarations */
/* eslint-disable no-unused-vars */
// const CONSTANTS = require('../../commons/constants')

let isProspectorParser = false
let currentUrl = ''
let documentObject = ''
let isServerParserEnabled = false
let isServerParserEnabledTriggered = false
let LI_CHOOSEN_LANGUAGE = ''

let WEB_URL = 'http://localhost:8080/'
if (process.env.VUE_APP_BUILD_ENV === 'staging') {
  WEB_URL = 'https://www.adaptqe.com/'
} else if (process.env.VUE_APP_BUILD_ENV === 'production') {
  WEB_URL = 'https://www.adapt.io/'
}
const experienceSectionV1Xpath = '//section[contains(@id, "EXPERIENCE")]'
const experienceSectionV1ItemXpath =
  './/li[contains(@class,"artdeco-list__item")]'

const experienceSectionV2Xpath = '//*[@id="experience"]/parent::section'
const experienceSectionV2ItemXpath =
  './/li[contains(@class,"artdeco-list__item")]'
function checkIsProspectorWindow() {
  const host = window.location.host
  if (
    host.includes('http://localhost:8081') ||
    host.includes('https://prospectorv2.adaptqe.com') ||
    host.includes('https://prospectorv2.adapt.io')
  ) {
    return true
  }
  return false
}
const envErrorObj = {
  error: 'env_error',
  errorMessage: 'Environment value incorrect',
  data: {
    isProspectorParser
  }
}

if (!isProspectorParser && !checkIsProspectorWindow()) {
  function checkIsServerParserEnabled() {
    get('lp/isServerParserAllowed.htm').then(function(res) {
      if (res == 'true') {
        isServerParserEnabled = true
      } else {
        isServerParserEnabled = false
      }
    })
  }
  function get(path) {
    const url = WEB_URL + path
    return getFromUrl(url)
  }

  function getFromUrl(url) {
    const params = {
      url: url,
      method: 'GET',
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json'
      })
    }
    return sendRestCallToBg(params)
  }

  function sendRestCallToBg(data) {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line no-undef
      try {
        return (
          chrome &&
          chrome.runtime &&
          chrome.runtime.sendMessage(
            {
              method: 'rest',
              value: data
            },
            function(value) {
              resolve(value)
            }
          )
        )
      } catch (error) {
        return ''
      }
    })
  }
  if (!isServerParserEnabledTriggered) {
    isServerParserEnabledTriggered = true
    checkIsServerParserEnabled()
  }
}

export const singleParser = (stubData, isFromBg = false) => {
  if (
    stubData !== undefined &&
    stubData !== null &&
    stubData.isProspectorParser !== undefined &&
    stubData.isProspectorParser
  )
    isProspectorParser = true
  else isProspectorParser = false
  if (!setEnvBasedValues(stubData))
    return new Promise(resolve => {
      resolve(envErrorObj)
    })
  return new Promise(resolve => {
    return resolve(parseUserDataFromLIParserFun(isFromBg))
  })
}
export const bulkParser = (stubData, isFromBg = false) => {
  if (
    stubData !== undefined &&
    stubData !== null &&
    stubData.isProspectorParser !== undefined &&
    stubData.isProspectorParser
  )
    isProspectorParser = true
  else isProspectorParser = false
  if (!setEnvBasedValues(stubData))
    return new Promise(resolve => {
      resolve(envErrorObj)
    })
  if (isFromBg) {
    return new Promise(resolve => {
      return resolve(fetchBulkDataParserBgCrawl(isFromBg))
    })
  }
  return new Promise(resolve => {
    return resolve(fetchBulkDataParserFun(isFromBg))
  })
}
function constructDocumentObj(str) {
  let doc = document.implementation.createHTMLDocument('')
  doc.open('replace')
  doc.write(str)
  doc.close()
  return doc
}

function setEnvBasedValues(stubData) {
  try {
    if (isProspectorParser && stubData !== undefined && stubData !== null) {
      if (stubData.currentUrl) currentUrl = stubData.currentUrl
      if (stubData.htmlText)
        documentObject = constructDocumentObj(stubData.htmlText)
    } else {
      if (window) {
        window.location &&
          window.location.href &&
          (currentUrl = window.location.href)
        window.document && (documentObject = window.document)
      }
    }
    return true
  } catch (error) {
    console.log(
      'Environment value incorrect isProspectorParser',
      isProspectorParser
    )
    return false
  }
}
function getSearchStringFromUrl(urlVal = currentUrl) {
  let url_parts = {
    search: ''
  }
  url_parts = new URL(urlVal)
  return url_parts.search
}

function getPathname(urlVal = currentUrl) {
  let url_parts = {
    pathname: ''
  }
  url_parts = new URL(urlVal)
  return url_parts.pathname
}

function getPathnameWithQueryParam(urlVal = currentUrl) {
  let url_parts = {
    pathname: '',
    search: ''
  }
  url_parts = new URL(urlVal)
  return url_parts.pathname + url_parts.search
}

function trimSpacesAndNewLine(str) {
  return str
    .split('\n')
    .map(d => {
      if (d) {
        if (d.trim() == '') return ''
        return d.trim() + ' '
      }
      return ''
    })
    .join('')
    .trim()
}
function nullCheck(value) {
  if (value == undefined || value == null || value == '') {
    return true
  }
  return false
}

/* Single Parser Starts */
const parseUserDataFromLIParserFun = isFromBg => {
  return new Promise(resolve => {
    let profileData = {}
    if (isServerParserEnabled && !isFromBg) {
      profileData.isServerParserEnabled = true
      profileData.profileHTML = document.documentElement.innerHTML
      profileData.currentUrl = window.location.href
    } else {
      try {
        profileData.linkedinLanguage = getLinkedinSelectedLanguage()
        LI_CHOOSEN_LANGUAGE = profileData.linkedinLanguage

        let cName = getCompanyNameFromExpSec()
        let cAddress = getCompanyAddress(cName)
        let company = {
          domain: '',
          name: cName,
          address: cAddress
        }
        profileData.tryUserInfoSection = false
        profileData.source = 'LINKEDIN'
        profileData.company = company
        profileData.fullName = getFullName()
        profileData.firstName = getFirstName()
        profileData.lastName = getLastName()

        profileData.title = getTitle()
        profileData.linkedinCompanyPageUrl = getCurrentCompanyPageUrl()
        profileData.isActivelyWorking = isActivelyWorkingInFirstCompany()
        if (
          profileData.linkedinCompanyPageUrl &&
          hasLinkedInCompanyPage(profileData.linkedinCompanyPageUrl)
        ) {
          profileData.isValidDomain = true
        } else {
          profileData.isValidDomain = false
          profileData.linkedinCompanyPageUrl = null
        }
        profileData.listParameter = 'linkedin'
        const summrySct = getElementByClassNameFromDom(
          'pv-top-card-section__summary-text',
          0
        )
        profileData.otherEmails = getEmailsFromProfilePage(summrySct)
        profileData.city = getCity()
        profileData.connections = getConnections()
        profileData.twitterId = getTwitterId()
        profileData.linkedinId = getLinkedinId()
        profileData.personalEmailId = getPersonalEmail()
        profileData.experience = getPastExperience()
        profileData.activeCompanyLIURLs = getAllActiveCompanies()
        profileData.linkedInProfileId = getLinkedInProfileId()
        profileData.address = getAddress()
        profileData.imageUrl = getImageUrl()
        profileData.profileHeadline = getProfileHeadline()
        if (getPhone() && getPhone().length > 0) {
          profileData.phoneNumber = [getPhone()] //return as list
        }
        profileData.isSaleNavigator = isSalesNavigator()

        if (
          (nullCheck(cName) &&
            (nullCheck(profileData.experience) ||
              profileData.experience.length == 0)) ||
          nullCheck(profileData.fullName) ||
          nullCheck(profileData.title) ||
          nullCheck(profileData.linkedinId)
        ) {
          profileData.domReadError = true
          profileData.profileHTML = document.documentElement.innerHTML
          profileData.currentUrl = window.location.href
        }
      } catch (err) {
        profileData.domReadError = true
        profileData.profileHTML = document.documentElement.innerHTML
        profileData.currentUrl = window.location.href

        return resolve(profileData)
      }
    }
    return resolve(profileData)
  })
}

function getLinkedinSelectedLanguage() {
  const languageMetaElement = documentObject.querySelector(
    "meta[name='i18nLocale']"
  )
  const selectLangauageElement = document.querySelector(
    '#globalfooter-select_language'
  )
  let languageText = ''
  if (languageMetaElement !== null)
    languageText = languageMetaElement.getAttribute('content')
  else if (selectLangauageElement !== null)
    languageText = selectLangauageElement.value

  return languageText
}

function getCompanyNameFromExpSec() {
  let company
  if (isNotSalesNavigator()) {
    let companySection = getDataByClassNameTagName(
      'experience-section',
      0,
      'li',
      0
    )
    const recentExperience = getLatestExperienceInfo()
    if (companySection) {
      company = getTagNameElementFromHTMLElement(companySection, 'a', 0)

      if (isValidCompany(company)) {
        let name = getClassNameElementFromHTMLElement(
          company,
          'pv-entity__secondary-title',
          0
        )
        if (name != undefined) {
          return trimSpacesAndNewLine(name.innerText)
        }
        name =
          documentObject.querySelectorAll(
            '.pv-entity__company-summary-info h3 span'
          ) &&
          documentObject.querySelectorAll(
            '.pv-entity__company-summary-info h3 span'
          ).length > 1
            ? documentObject.querySelectorAll(
                '.pv-entity__company-summary-info h3 span'
              )[1]
            : null
        if (name != null) {
          return trimSpacesAndNewLine(name.innerText)
        }
      }
    } else if (recentExperience) {
      return getCompanyNameFromV1GroupEXPERIENCE(recentExperience)
    }
  } else {
    if (isSalesNavigatorLead()) {
      const companyName =
        getElementByXpath(
          "//*[@id='experience-section']/ul/li[1]/div/div/a/p"
        ) ||
        documentObject.querySelector(
          "#experience-section [data-anonymize='company-name']"
        )
      if (companyName) return trimSpacesAndNewLine(companyName.innerText)
    } else {
      let companyData = documentObject.querySelector('#profile-experience')
      if (companyData) {
        companyData = companyData.getElementsByTagName('li')
        if (companyData[0]) {
          companyData = companyData[0].querySelector(
            '.profile-position__secondary-title'
          )
          if (companyData) {
            return trimSpacesAndNewLine(companyData.innerText).replace(
              'Company Name',
              ''
            )
          }
        }
      }
    }
  }
}

function getCompanyAddress(cName) {
  if (cName && isNotSalesNavigator()) {
    let companySection = getDataByClassNameTagName(
      'experience-section',
      0,
      'li',
      0
    )
    const recentExperience = getLatestExperienceInfo()
    if (companySection) {
      const addressSection = companySection.querySelector(
        '.pv-entity__location'
      )
      if (addressSection) {
        const hiddenEle = addressSection.querySelector(
          '.pv-entity__location .visually-hidden'
        )
        const hiddenTxt = hiddenEle ? hiddenEle.innerText.trim() : ''
        return trimSpacesAndNewLine(addressSection.innerText)
          .replace(hiddenTxt, '')
          .replace(/(?:\r\n|\r|\n)/g, '')
      }
    } else if (recentExperience) {
      return getAddressFromV1GroupEXPERIENCE(recentExperience)
    }
  }
}

function getFullName() {
  if (isNotSalesNavigator()) {
    const profileV3 = documentObject.querySelector('.pv-top-card-v3')
    const profileV4 = documentObject.querySelector(
      '.pv-text-details__left-panel'
    )
    const profileV5 = documentObject.querySelector('.pv-top-card--list')
    let nameSection
    if (profileV3) {
      nameSection = profileV3.querySelector('h1')
      if (!nameSection) {
        nameSection = profileV3.querySelector('.pv-top-card-v3--list')
        if (nameSection) nameSection = nameSection.querySelector('li')
      }
      return trimSpacesAndNewLine(nameSection.innerText)
    } else if (profileV4) {
      if (profileV4.querySelector('h1')) {
        return trimSpacesAndNewLine(profileV4.querySelector('h1').innerText)
      }
    } else if (profileV5) {
      if (profileV5.querySelector('li')) {
        return trimSpacesAndNewLine(profileV5.querySelector('li').innerText)
      }
    } else {
      nameSection = getElementByClassNameFromDom('pv-top-card-section__name', 0)
      if (!nameSection)
        nameSection = documentObject.querySelector('.topcard__name')
    }
    return nameSection ? trimSpacesAndNewLine(nameSection.innerText) : ''
  } else {
    if (isSalesNavigatorLead()) {
      const name = documentObject.querySelector(
        '#profile-card-section section h1'
      )
      if (name !== null) return trimSpacesAndNewLine(name.innerText)
    } else {
      let nameElem = getElementByClassNameFromDom('member-name', 0)
      if (nameElem == undefined) {
        nameElem = getElementByClassNameFromDom(
          'profile-topcard-person-entity__name',
          0
        )
      }
      return trimSpacesAndNewLine(nameElem.innerText)
      //  for salesnavigator
    }
  }
}

function getFirstName() {
  const names = splitBySpace(getFullName())
  if (names[0]) return names[0]
}

function getLastName() {
  const names = splitBySpace(getFullName())
  if (names[1]) return names[1]
}

function getLatestExperienceInfo() {
  const expSectionV1 = getElementByXpath(experienceSectionV1Xpath)
  const expSectionV2 = getElementByXpath(experienceSectionV2Xpath)
  if (expSectionV1) {
    const recentExperience = getElementByXpath(
      experienceSectionV1ItemXpath,
      expSectionV1
    )
    return recentExperience
  } else if (expSectionV2) {
    const recentExperience = getElementByXpath(
      experienceSectionV2ItemXpath,
      expSectionV2
    )
    return recentExperience
  }
}

function getTitle() {
  let titleSection
  if (isNotSalesNavigator()) {
    const expSection = getElementByClassNameFromDom('pv-position-entity', 0)
    const recentExperience = getLatestExperienceInfo()
    if (expSection) {
      if (hasMulitpleTitle(expSection)) {
        const temp = getTagNameElementFromHTMLElement(expSection, 'li', 0)
        if (temp) {
          titleSection = getTagNameElementFromHTMLElement(temp, 'h3', 0)
        }
        if (titleSection && titleSection.innerText) {
          return trimSpacesAndNewLine(titleSection.innerText).replace(
            'Title',
            ''
          )
        }
      } else {
        titleSection = getTagNameElementFromHTMLElement(expSection, 'h3', 0)
      }
    } else if (recentExperience) {
      return getTitleFromV1GroupEXPERIENCE(recentExperience)
    }
  } else {
    if (isSalesNavigatorLead()) {
      const title = documentObject.querySelector(
        "#profile-card-section [data-anonymize='headline']"
      )
      if (title !== null) {
        return title.innerText
      } else {
        const title = getElementByXpath(
          "//*[@id='profile-card-section']/section[1]/div/div[3]/span"
        )
        if (title !== null) {
          return title.innerText
        }
      }
    } else {
      titleSection = getDataByClassNameTagName('position-info', 0, 'h2', 0)
      if (!titleSection) {
        titleSection = getDataByClassNameClassName(
          'profile-position',
          0,
          'profile-position__title',
          0
        )
      }
    }
  }
  if (titleSection) {
    return trimSpacesAndNewLine(titleSection.innerText)
  }
}

function getCurrentCompanyPageUrl() {
  let company
  if (isNotSalesNavigator()) {
    let companySection = getDataByClassNameTagName(
      'experience-section',
      0,
      'li',
      0
    )
    const recentExperience = getLatestExperienceInfo()
    if (companySection) {
      company = getTagNameElementFromHTMLElement(companySection, 'a', 0)
      if (isValidCompany(company)) {
        let currentCompany = getPathnameWithQueryParam(company.href)

        if (currentCompany.indexOf('www.linkedin.com') == -1) {
          currentCompany = 'https://www.linkedin.com' + currentCompany
        }
        return currentCompany
      }
    } else if (recentExperience) {
      const isActivelyWorkingInRecentCompany = getActivelyWorkingInfoFromV1GroupEXPERIENCE(
        recentExperience
      )
      if (isActivelyWorkingInRecentCompany) {
        let company = getElementByXpath('./div/div[1]/a', recentExperience)
        if (company) {
          let currentCompany = getPathnameWithQueryParam(company.href)

          if (currentCompany.indexOf('www.linkedin.com') == -1) {
            currentCompany = 'https://www.linkedin.com' + currentCompany
          }
          return currentCompany
        }
      }
    }
  } else {
    if (isSalesNavigatorLead()) {
      const companyName = documentObject.querySelector(
        "#experience-section li p[data-anonymize='company-name']"
      )
      if (companyName !== null) {
        const companyLinkedinURL =
          'https://www.linkedin.com' +
          companyName.parentElement.getAttribute('href')
        return companyLinkedinURL
      } else if (
        getElementByXpath("//*[@id='experience-section']/ul/li[1]/div/div/a")
      ) {
        return (
          'https://www.linkedin.com' +
          getElementByXpath(
            "//*[@id='experience-section']/ul/li[1]/div/div/a"
          ).getAttribute('href')
        )
      }
    } else {
      company = getDataByClassNameTagName('position', 0, 'a', 0)
      if (company) {
        return getCompanyUrlSn(company)
      } else {
        company = getDataByClassNameTagName('profile-position', 0, 'a', 0)
        return getCompanyUrlForNewSn(company)
      }
    }
  }
}

function isActivelyWorkingInFirstCompany() {
  if (isNotSalesNavigator()) {
    let companyData = documentObject.querySelector(
      '.pv-entity__position-group-pager'
    )
    const recentExperience = getLatestExperienceInfo()
    if (companyData && checkIsPresentTextMatch(companyData.innerText)) {
      return true
    } else if (recentExperience) {
      return getActivelyWorkingInfoFromV1GroupEXPERIENCE(recentExperience)
    }
  } else {
    if (isSalesNavigatorLead()) {
      const latestCompany = documentObject.querySelector(
        '#experience-section ul li:first-child'
      )
      if (latestCompany !== null) {
        return checkIsPresentTextMatch(latestCompany.innerText)
      }
    } else {
      let companyData = documentObject.querySelector('#profile-experience')
      if (companyData) {
        companyData = companyData.getElementsByTagName('li')
        if (companyData[0]) {
          return checkIsPresentTextMatch(companyData[0].innerText)
        }
      }
    }
  }
}

function getEmailsFromProfilePage(content) {
  return findWordsContainingKey('@', content)
}

function getCity() {
  let location
  if (isNotSalesNavigator()) {
    location = getElementByClassNameFromDom('pv-top-card-section__location', 0)
  } else {
    if (isSalesNavigatorLead()) {
      location =
        documentObject.querySelector(
          "#profile-card-section [data-anonymize='location']"
        ) ||
        getElementByXpath(
          "//*[@id='profile-card-section']/section[1]/div/div[4]"
        )
    } else {
      location = getElementByClassNameFromDom('location', 6)
      if (!location) {
        location = getElementByClassNameFromDom('location', 0)
      }
      if (!location) {
        location = getElementByClassNameFromDom(
          'profile-topcard__location-data',
          0
        )
      }
    }
  }

  if (location != undefined && location.innerText.length > 0) {
    return trimSpacesAndNewLine(location.innerText).split(',')[0]
  }
}

function getConnections() {
  if (isNotSalesNavigator()) {
    let element = getContactInfoDom()
    if (element && element.querySelectorAll('li').length) {
      let connection = ''
      element.querySelectorAll('li').forEach(function(eleItem) {
        let data = eleItem.innerText
        if (data.includes('connection')) {
          connection = trimSpacesAndNewLine(data).replace(/\D/g, '')
        }
      })
      return connection
      //convert string to number
    }
  }
}

function getTwitterId() {
  if (isNotSalesNavigator()) {
    let twtELement = getDataByClassNameTagName('ci-twitter', 0, 'a', 0)
    if (twtELement != undefined) {
      return trimSpacesAndNewLine(twtELement.innerText)
    }
  } else {
    let contactInfoSection = getElementByClassNameFromDom('more-info-tray', 0)
    if (!contactInfoSection) {
      contactInfoSection = getElementByClassNameFromDom(
        'profile-topcard__contact-info',
        0
      )
    }
    if (contactInfoSection) {
      let aTags = getTagNameElementFromHTMLElement(contactInfoSection, 'a')
      if (aTags) {
        for (let aTag of aTags) {
          if (aTag.href && aTag.href.includes('twitter')) {
            let twitterUrl = new URL(aTag.href)
            let twitterId = twitterUrl.pathname.replace('/', '')
            return twitterId
          }
        }
      }
    }
  }
}

function getLinkedinId() {
  if (isNotSalesNavigator()) {
    let element = getDataByClassNameTagName('ci-vanity-url', 0, 'a', 0)
    if (element != undefined) {
      return trimSpacesAndNewLine(element.innerText)
    } else {
      return constructLinkedinIdFromWindowUrl()
    }
  } else {
    //if(){
    //}else{
    //  return constructLinkedinIdFromWindowUrl('sn');
    //}
  }
}

function getPersonalEmail() {
  if (isNotSalesNavigator()) {
    let personalEmailElement = getDataByClassNameTagName('ci-email', 0, 'a', 0)
    if (personalEmailElement != undefined) {
      return trimSpacesAndNewLine(personalEmailElement.innerText)
    }
  } else if (isSalesNavigatorLead()) {
    const email = documentObject.querySelector(
      '#profile-card-section address a[href*=mailto] span:last-child'
    )
    return trimSpacesAndNewLine(email.innerText)
  }
}

function getPastExperience() {
  // Existing flow using pastExperience for business logic,
  // this should be remove when active company changes are implemented o server
  return getExperienceDetails()
}

function getAllActiveCompanies() {
  if (isNotSalesNavigator()) {
    let allExp = getExperienceDetails()
    let activeCompanies = []
    for (let exp of allExp) {
      if (exp.timeline && exp.liCompanyUrl) {
        if (checkIsPresentTextMatch(exp.timeline)) {
          activeCompanies.push(exp.liCompanyUrl)
        }
      }
    }
    if (getCurrentCompanyPageUrl()) {
      let currentCompany = getCurrentCompanyPageUrl()

      currentCompany =
        'linkedin.com' + getPathnameWithQueryParam(currentCompany)
      activeCompanies.push(currentCompany)
    }
    return activeCompanies
  }
}

function getLinkedInProfileId() {
  if (isNotSalesNavigator() || isSalesNavigatorLead()) {
    return getLinkedInProfileIdFromRglrProfile()
  } else {
    const proflName = getElementByClassNameFromDom('member-name', 0)
    if (proflName) {
      return getLinkedinIdFromSalesnavigatorPrfl()
    }
    return null
  }
}

function getAddress() {
  if (isNotSalesNavigator()) {
    const dom = documentObject.querySelector(
      '.pv-text-details__left-panel .pb2'
    )
    const domV2 = documentObject.querySelector(
      '[data-control-name="contact_see_more"]'
    )
    if (dom) {
      const element = dom.querySelectorAll('span')
      if (element.length) {
        let addressText = ''
        element.forEach(function(eleItem) {
          const address = trimSpacesAndNewLine(eleItem.innerText)
          const lcAddress = address.toLowerCase()
          if (
            !lcAddress.includes('connection') &&
            !lcAddress.includes('contact info')
          ) {
            addressText = address
          }
        })
        return addressText
      }
    } else if (domV2) {
      let element = domV2.closest('ul')
      if (element && element.querySelector('li')) {
        const address = trimSpacesAndNewLine(
          element.querySelector('li').innerText
        )
        const lowerCaseAddress = address.toLowerCase()
        if (
          lowerCaseAddress.includes('connection') ||
          lowerCaseAddress.includes('contact info')
        ) {
          return ''
        } else {
          return address
        }
        //convert string to number
      }
    }
  }
}

function getImageUrl() {
  let imageDom
  if (isNotSalesNavigator()) {
    imageDom = getElementByClassNameFromDom('pv-top-card-section__photo', 0)
    if (imageDom && imageDom.style && imageDom.style.backgroundImage) {
      let imageUrl = imageDom.style.backgroundImage
        .slice(4, -1)
        .replace(/["']/g, '')
      return imageUrl
    }
  } else {
    if (isSalesNavigatorLead()) {
      imageDom = documentObject.querySelector(
        '#profile-card-section [class*=profile-photo] img'
      )
    } else {
      imageDom = getElementByClassNameFromDom('entity-image', 0)
    }
    if (imageDom && imageDom.src) {
      return imageDom.src
    }
  }
}

function getProfileHeadline() {
  let value
  if (isNotSalesNavigator()) {
    value = getElementByClassNameFromDom('pv-top-card-section__headline', 0)
  } else {
    if (isSalesNavigatorLead()) {
      value = documentObject.querySelector(
        "#profile-card-section [data-anonymize='headline']"
      )
    } else {
      const holder = getElementByClassNameFromDom(
        'profile-topcard-person-entity__content',
        0
      )
      if (holder) {
        value = getTagNameElementFromHTMLElement(holder, 'dd', 0)
      }
    }
  }
  if (value && value.innerText) {
    return trimSpacesAndNewLine(value.innerText)
  }
}

function getPhone() {
  if (isNotSalesNavigator()) {
    let element = getDataByClassNameTagName('ci-phone', 0, 'a', 0)
    if (element != undefined) {
      let phone = element.href.replace('tel:', '')
      return phone
    }
  }
}

function getCurentUrl() {
  return currentUrl
}

function getCompanyUrlForNewSn(company) {
  if (
    isValidCompany(company, 'sn_new') &&
    company &&
    company.pathname &&
    company.pathname != '/single'
  ) {
    let companyHref = getPathname(company.href)
    const urlSplit = companyHref.split('/')
    const companyId = urlSplit[urlSplit.length - 1]
    if (companyId) {
      let companyUrl = 'linkedin.com/company/' + companyId + '/'
      return companyUrl
    }
  }
}

function getCompanyUrlSn(company) {
  if (isValidCompany(company, 'sn')) {
    let url = new URL(company.href)
    if (url.searchParams.get('companyId') != undefined) {
      let companyUrl =
        'linkedin.com/company/' + url.searchParams.get('companyId') + '/'
      return companyUrl
    }
  }
}

function getContactInfoDom() {
  const dom = documentObject.querySelector(
    '[data-control-name="contact_see_more"]'
  )
  const domV2 = documentObject.querySelector('.pv-top-card--list-bullet')
  if (dom) {
    return dom.closest('ul')
  } else if (domV2) {
    return domV2
  }
}

function isValidCompany(company, arg) {
  if (company != undefined && isCurrentCompany(company, arg)) {
    return true
  }
}

function getLinkedinIdFromSalesnavigatorPrfl() {
  let temp = getElementByClassNameFromDom('save-lead-container actions-form', 0)
  let contents = getTagNameElementFromHTMLElement(temp, 'input')
  for (var content of contents) {
    if (content.name === 'memberId') {
      return content.value
    }
  }
}

function isNotSalesNavigator() {
  return !isSalesNavigator()
}

function hasLinkedInCompanyPage(url) {
  return url.indexOf('search/results/index') == -1
}

function splitBySpace(name) {
  return name.split(' ')
}

function isSalesNavigator() {
  return getCurentUrl().indexOf('/sales/') != -1
}

function isSalesNavigatorLead() {
  return getCurentUrl().indexOf('/sales/lead') != -1
}

function getExperienceDetails() {
  let pastExp = []
  if (isNotSalesNavigator()) {
    const expSect = getElementByClassNameFromDom('experience-section', 0)
    const expSectionV1GroupEXPERIENCE = getElementByXpath(
      experienceSectionV1Xpath
    )
    const expSecttionUsingID = getElementByXpath(experienceSectionV2Xpath)
    if (expSect) {
      let targetClass = 'pv-entity__position-group-pager'
      const allExp = getClassNameElementFromHTMLElement(expSect, targetClass)

      if (allExp) {
        let iteration = 0
        for (const exp of allExp) {
          iteration++
          if (iteration != 1) {
            //skip the first company
            if (exp != undefined) {
              const data = getCompanyInfo(exp)
              pastExp.push(data)
            }
          }
        }
      }
    } else {
      let allExp = null
      if (expSectionV1GroupEXPERIENCE)
        allExp = getElementsByXpath(
          experienceSectionV1ItemXpath,
          expSectionV1GroupEXPERIENCE
        )
      else if (expSecttionUsingID)
        allExp = getElementsByXpath(
          experienceSectionV2ItemXpath,
          expSecttionUsingID
        )

      if (allExp) {
        let iteration = 0
        for (const exp of allExp) {
          iteration++
          if (iteration != 1) {
            //skip the first company
            if (exp != undefined) {
              const data = getCompanyInfoFromExpSectionV1GroupEXPERIENCE(exp)
              pastExp.push(data)
            }
          }
        }
      }
    }
  }
  return pastExp
}

function getInnerTextUsingXpath(xpath, element, oldvalue) {
  if (!oldvalue) {
    const sectionData = getElementByXpath(xpath, element)
    if (sectionData)
      return trimSpacesAndNewLine(sectionData.innerText).replace(
        /(?:\r\n|\r|\n)/g,
        ''
      )
  }
  return oldvalue
}

function checkStringContainsNumber(str) {
  return /\d/.test(str)
}

function getTitleFromV1GroupEXPERIENCE(element) {
  const titleXpathMap = [
    './/div[2] /div/div/div/span/span[1]',
    './/div[2] //ul[contains(@class, "pvs-list")] //div[2] /div/a//span[contains(@class, "mr1")]/span[1]'
  ]
  let title
  titleXpathMap.map(item => {
    let companyText = getInnerTextUsingXpath(item, element)
    if (companyText && !title) title = companyText.trim()
  })
  return title
}

function getCompanyNameFromV1GroupEXPERIENCE(element) {
  const companyNameXpathMap = [
    './/div[2] /div/div/span[1]/span[1]',
    './/div[2] //a[contains(@data-field,"experience_company_logo")]/div/span/span[1]'
  ]
  let companyName
  companyNameXpathMap.map(item => {
    let companyText = getInnerTextUsingXpath(item, element)
    if (companyText && !companyName)
      companyName = companyText
        .replace('· Full-time', '')
        .replace('· Part-time', '')
        .trim()
  })
  return companyName
}

function getActivelyWorkingInfoFromV1GroupEXPERIENCE(element) {
  const experienceXpathMap = [
    './/div[2] /div/div/span[2]/span[1]',
    './/div[2] //ul[contains(@class, "pvs-list")] //div[2] /div/a/span[1]/span[1]',
    './/div[2] //ul[contains(@class, "pvs-list")] //div[2] /div/a/span[2]/span[1]'
  ]
  let isActivelyWorking = false
  experienceXpathMap.map(item => {
    let expText = getInnerTextUsingXpath(item, element)
    if (expText && checkIsPresentTextMatch(expText)) isActivelyWorking = true
  })
  return isActivelyWorking
}

function getAddressFromV1GroupEXPERIENCE(element) {
  const addressXpathMap = [
    './/div[2] /div/div/span[3]/span[1]',
    './/div[2] //ul[contains(@class, "pvs-list")] //div[2] /div/a/span[last()]/span[1]',
    './/div[2] /div/a/span[last()]/span[1]'
  ]
  let address = ''
  addressXpathMap.map(item => {
    let addrText = getInnerTextUsingXpath(item, element)
    if (
      addrText &&
      !checkIsPresentTextMatch(addrText) &&
      !checkStringContainsNumber(addrText)
    )
      address = addrText
  })
  return address
}

function getCompanyInfoFromExpSectionV1GroupEXPERIENCE(element) {
  let data = {}
  data.isVerifiedDomain = false //set default

  data.title = getTitleFromV1GroupEXPERIENCE(element)
  data.companyName = getCompanyNameFromV1GroupEXPERIENCE(element)
  data.isActivelyWorking = getActivelyWorkingInfoFromV1GroupEXPERIENCE(element)
  data.address = getAddressFromV1GroupEXPERIENCE(element)

  let liUrlSection = getElementByXpath('./div/div[1]/a', element)
  if (
    liUrlSection &&
    liUrlSection.href &&
    (hasLinkedInCompanyPage(liUrlSection.href) ||
      (isProspectorParser && hasLinkedInCompanyPage(currentUrl)))
  ) {
    data.companyUrl =
      'linkedin.com' + getPathnameWithQueryParam(liUrlSection.href)
    data.isVerifiedDomain = true
  }
  return data
}

function getCompanyInfo(element) {
  let data = {}
  data.isVerifiedDomain = false //set default
  const titleSection = getTitleSectionFromCompanyInfo(element)

  let companyNameSection = getClassNameElementFromHTMLElement(
    element,
    'pv-entity__secondary-title',
    0
  )
  const expDateSection = getClassNameElementFromHTMLElement(
    element,
    'pv-entity__date-range',
    0
  )
  const locationSection = getClassNameElementFromHTMLElement(
    element,
    'pv-entity__location',
    0
  )
  let liUrlSection = element.parentNode
  if (
    element &&
    element.querySelector('li') &&
    element.querySelector('li').querySelector('a')
  ) {
    liUrlSection = element.querySelector('li').querySelector('a')
  } else if (element && element.querySelector('a')) {
    liUrlSection = element.querySelector('a')
  }

  if (titleSection && titleSection.innerText) {
    data.title = trimSpacesAndNewLine(titleSection.innerText).replace(
      'Title',
      ''
    )
  }
  if (companyNameSection) {
    data.companyName = trimSpacesAndNewLine(companyNameSection.innerText)
  }
  if (
    data.companyName == undefined ||
    data.companyName == null ||
    data.companyName == ''
  ) {
    companyNameSection =
      element.querySelectorAll('.pv-entity__company-summary-info h3 span') &&
      element.querySelectorAll('.pv-entity__company-summary-info h3 span')
        .length > 1
        ? element.querySelectorAll(
            '.pv-entity__company-summary-info h3 span'
          )[1]
        : null
    if (companyNameSection != null) {
      data.companyName = trimSpacesAndNewLine(companyNameSection.innerText)
    }
  }
  if (expDateSection) {
    const timeline = trimSpacesAndNewLine(expDateSection.innerText).replace(
      'Dates Employed',
      ''
    )
    if (checkIsPresentTextMatch(timeline)) {
      data.isActivelyWorking = true
    } else {
      data.isActivelyWorking = false
    }
  }
  if (locationSection) {
    const hiddenEle = element.querySelector(
      '.pv-entity__location .visually-hidden'
    )
    const hiddenTxt = hiddenEle ? hiddenEle.innerText.trim() : ''
    data.address = trimSpacesAndNewLine(locationSection.innerText)
      .replace(hiddenTxt, '')
      .replace(/(?:\r\n|\r|\n)/g, '')
  }
  if (
    liUrlSection &&
    liUrlSection.href &&
    (hasLinkedInCompanyPage(liUrlSection.href) ||
      (isProspectorParser && hasLinkedInCompanyPage(currentUrl)))
  ) {
    data.companyUrl =
      'linkedin.com' + getPathnameWithQueryParam(liUrlSection.href)
    data.isVerifiedDomain = true
  }
  return data
}

function getLinkedInProfileIdFromRglrProfile() {
  let domContent = getTagNameElementFromDom('code')
  for (let i = 0; i < domContent.length; i++) {
    let text = trimSpacesAndNewLine(domContent[i].innerText)
    if (
      text.indexOf(getFirstName()) != -1 &&
      text.indexOf('urn:li:member:') != -1
    ) {
      let profDataJson = JSON.parse(text)
      let allProfileContactList = profDataJson.included
      if (allProfileContactList.length > 0) {
        let fullName = getFullName()
        for (let j = 0; j < allProfileContactList.length; j++) {
          if (
            fullName.indexOf(allProfileContactList[j].firstName) != -1 &&
            allProfileContactList[j].objectUrn != undefined
          ) {
            var linkedinProfileId = allProfileContactList[j].objectUrn
            linkedinProfileId = linkedinProfileId.replace('urn:li:member:', '')
            return linkedinProfileId
          }
        }
      }
    }
  }
}

function getTitleSectionFromCompanyInfo(element) {
  let target
  if (element) {
    const allReferenceEle = element.querySelectorAll('.visually-hidden')
    for (let ele of allReferenceEle) {
      if (ele.innerText.indexOf('Title') != -1) {
        return ele.parentElement
      }
    }
  }
  target = getTagNameElementFromHTMLElement(element, 'h3', 0)
  return target
}
function constructLinkedinIdFromWindowUrl(arg) {
  if (arg == undefined) {
    let pathname = getPathname()
    if (pathname[pathname.length - 1] == '/') {
      pathname = pathname.substring(0, pathname.length - 1)
    }
    let linkedinId = 'linkedin.com' + pathname
    return linkedinId
  }
}

function getDataByClassNameTagName(className, classNode, tagName, tagNode) {
  let dataSection = getElementByClassNameFromDom(className, classNode)
  if (dataSection != undefined) {
    let dataElement = getTagNameElementFromHTMLElement(
      dataSection,
      tagName,
      tagNode
    )
    return dataElement
  }
}

function hasMulitpleTitle(expSection) {
  return getClassNameElementFromHTMLElement(
    expSection,
    'pv-entity__role-details',
    0
  )
}

function getElementByClassNameFromDom(className, node) {
  let value = documentObject.getElementsByClassName(className)
  if (node != null) {
    // dont replace with if(node) as node value can be 0
    if (value[node]) {
      return value[node]
    }
  } else {
    return value
  }
}

function getElementByXpath(path, element) {
  return document.evaluate(
    path,
    element || documentObject,
    null,
    XPathResult.FIRST_ORDERED_NODE_TYPE,
    null
  ).singleNodeValue
}

function getElementsByXpath(path, element) {
  let results = []
  let query = document.evaluate(
    path,
    element || documentObject,
    null,
    XPathResult.ORDERED_NODE_SNAPSHOT_TYPE,
    null
  )
  for (let i = 0, length = query.snapshotLength; i < length; ++i) {
    results.push(query.snapshotItem(i))
  }
  return results
}

function findWordsContainingKey(key, content) {
  if (content) {
    content = trimSpacesAndNewLine(content.innerText)
    const regex = new RegExp('\\S+[a-z0-9]' + key + '[a-z0-9.]+', 'gim')
    return content.match(regex)
  }
}

function getTagNameElementFromDom(tagName, node) {
  let value = documentObject.getElementsByTagName(tagName)
  if (node != null) {
    // if(node) is not used because, if node = 0 it become false
    if (value[node]) {
      return value[node]
    }
  } else {
    return value
  }
}

function getDataByClassNameClassName(class1, classNode1, class2, classNode2) {
  let dataSection = getElementByClassNameFromDom(class1, classNode1)
  if (dataSection != undefined) {
    let dataElement = getClassNameElementFromHTMLElement(
      dataSection,
      class2,
      classNode2
    )
    return dataElement
  }
}

function getTagNameElementFromHTMLElement(element, tagName, node) {
  if (element && element.getElementsByTagName(tagName).length > 0) {
    let value = element.getElementsByTagName(tagName)
    if (node != null) {
      // if(node) is not used because, if node = 0 it become false
      if (value[node]) {
        return value[node]
      }
    } else {
      return value
    }
  }
}

function getClassNameElementFromHTMLElement(element, className, node) {
  let value = element.getElementsByClassName(className)
  if (node != null) {
    if (value[node]) {
      return element.getElementsByClassName(className)[node]
    }
  } else {
    return value
  }
}

function isCurrentCompany(element, arg) {
  let dateRange
  if (arg && arg === 'sn_new') {
    let dataSection = element.parentElement
    dateRange = getClassNameElementFromHTMLElement(
      dataSection,
      'profile-position__dates-employed',
      0
    )
  } else if (arg) {
    let dataSection = element.parentElement.parentElement
    dateRange = getTagNameElementFromHTMLElement(dataSection, 'span', 0)
  } else {
    element = element.closest('li')
    let dataSection = getClassNameElementFromHTMLElement(
      element,
      'pv-entity__date-range',
      0
    )
    dateRange = getTagNameElementFromHTMLElement(dataSection, 'span', 1)
  }

  if (dateRange != undefined) {
    let presentParseStr = dateRange.innerText
    const dateSplitArr1 = presentParseStr.split('–')
    const dateSplitArr2 = presentParseStr.split('-')

    if (dateSplitArr1.length > 1) presentParseStr = dateSplitArr1[1]
    else if (dateSplitArr2.length > 1) presentParseStr = dateSplitArr2[1]

    const isMatched = checkIsPresentTextMatch(presentParseStr)
    return isMatched
  }
  return false
}
/* Single Parser Ends */

/* Bulk Parser Starts */
const fetchBulkDataParserFun = isFromBg => {
  return new Promise(resolve => {
    if (isSalesNavigatorList()) {
      isAllContentsLoadedInSalesNavigatorList(0).then(() => {
        resolve(getAllProfileDataBulk(documentObject, isFromBg))
      })
    } else if (!isSalesnavigatorBulk()) {
      isAllContentsLoaded(0).then(() => {
        resolve(getAllProfileDataBulk(documentObject, isFromBg))
      })
    } else {
      isAllContentsLoadedInSalesNavigator(0).then(() => {
        resolve(getAllProfileDataBulk(documentObject, isFromBg))
      })
    }
  })
}

const fetchBulkDataParserBgCrawl = isFromBg => {
  return new Promise(resolve => {
    resolve(getAllProfileDataBulk(documentObject, isFromBg))
  })
}

function isAllContentsLoaded(i) {
  return delay(400).then(() => {
    if (!isProspectorParser) window.scrollBy(0, 300)
    let totalContacts = 0
    let totalLoaded = 0
    if (documentObject.querySelectorAll('.search-results__list')[0]) {
      totalContacts = documentObject
        .querySelectorAll('.search-results__list')[0]
        .querySelectorAll('li').length
      totalLoaded = documentObject.querySelectorAll('.search-result__image')
        .length
    } else if (
      documentObject.querySelectorAll(
        '.reusable-search__entity-results-list'
      )[0]
    ) {
      totalContacts = documentObject
        .querySelectorAll('.reusable-search__entity-results-list')[0]
        .querySelectorAll('li').length
      totalLoaded = documentObject.querySelectorAll('.entity-result__item')
        .length
    }
    if (totalLoaded == totalContacts) {
      if (!isProspectorParser) window.scrollTo(0, 0)
      return
    } else {
      i++
      if (i < 4 && !isProspectorParser) {
        return isAllContentsLoaded(i)
      } else {
        return
      }
    }
  })
}

function isAllContentsLoadedInSalesNavigatorList(i) {
  return delay(300).then(() => {
    if (!isProspectorParser) window.scrollBy(0, 300)
    const totalResults = document.querySelectorAll('.artdeco-models-table-row')
    let totalContacts =
      totalResults.length && totalResults.length > 25 ? totalResults.length : 25

    const totalLoadedV1 = documentObject.querySelectorAll(
      '.lists-detail__view-profile-name-link'
    ).length

    const totalLoadedV2 = documentObject.querySelectorAll(
      '.list-detail_name-and_badge div:first-child button span'
    ).length

    const totalLoaded = totalLoadedV1 || totalLoadedV2

    if (totalLoaded >= totalContacts) {
      if (!isProspectorParser) window.scrollTo(0, 0)
      return
    } else {
      i++
      if (i < 4 && !isProspectorParser) {
        return isAllContentsLoadedInSalesNavigatorList(i)
      } else {
        if (!isProspectorParser) window.scrollTo(0, 0)
        return
      }
    }
  })
}

function isAllContentsLoadedInSalesNavigator(i) {
  return delay(600).then(() => {
    if (!isProspectorParser) window.scrollBy(0, 300)
    const totalResults = documentObject.querySelector(
      '.artdeco-tab-primary-text'
    )
    let totalContacts = 25
    if (totalResults) {
      totalContacts = trimSpacesAndNewLine(totalResults.innerText)
        .split(',')
        .join('')
      totalContacts > 25 ? (totalContacts = 25) : ''
    }

    const totalLoaded = documentObject.querySelectorAll(
      'dt.result-lockup__name'
    ).length
    if (totalLoaded >= totalContacts) {
      if (!isProspectorParser) window.scrollTo(0, 0)
      return
    } else {
      i++
      if (i < 15 && !isProspectorParser) {
        return isAllContentsLoadedInSalesNavigator(i)
      } else {
        if (!isProspectorParser) window.scrollTo(0, 0)
        return
      }
    }
  })
}

function isSalesnavigatorBulk() {
  return getCurentUrl().indexOf('/sales/search/people') != -1
}

function isSalesNavigatorList() {
  return getCurentUrl().indexOf('/sales/lists/people') != -1
}

function delay(ms) {
  return new Promise(function(resolve, reject) {
    return setTimeout(resolve, ms)
  })
}

function getAllProfileDataBulk(dom, isFromBg) {
  let constactList = []
  if (isServerParserEnabled && !isFromBg) {
    const profileData = {}
    profileData.isServerParserEnabled = true
    profileData.profileHTML = document.documentElement.innerHTML
    profileData.currentUrl = window.location.href
    return profileData
  } else {
    if (isSalesNavigatorList()) {
      const list = documentObject.querySelectorAll(
        '.artdeco-models-table-row.ember-view'
      )
      if (list) {
        for (let item of list) {
          const contact = getContactDataFromSnList(item)
          if (
            contact &&
            contact.fullName !== undefined &&
            contact.fullName !== 'LinkedIn Member'
          )
            constactList.push(contact)
        }
      }
    } else if (!isSalesnavigatorBulk()) {
      let list = dom.querySelector('ul.search-results__list')
      let bulkParserType = 'v1'
      if (!list) {
        list = dom.querySelector('ul.reusable-search__entity-result-list')
        bulkParserType = 'v2'
      }
      if (list) {
        const items = list.querySelectorAll('li')
        for (let item of items) {
          const contact = getContactData(item, bulkParserType)
          if (
            contact &&
            contact.fullName !== undefined &&
            contact.fullName !== 'LinkedIn Member'
          )
            constactList.push(contact)
        }
      }
    } else {
      const list = documentObject.querySelectorAll('.result-lockup')
      const listV1 = documentObject.querySelectorAll('li.artdeco-list__item')

      if (list.length > 0) {
        for (let item of list) {
          const contact = getContactDataFromSn(item)
          if (
            contact &&
            contact.fullName !== undefined &&
            contact.fullName !== 'LinkedIn Member'
          )
            constactList.push(contact)
        }
      } else if (listV1.length > 0) {
        for (let item of listV1) {
          const contact = getContactDataFromSnV1(item)

          if (
            contact &&
            contact.fullName !== undefined &&
            contact.fullName !== 'LinkedIn Member'
          )
            constactList.push(contact)
        }
      }
    }
  }
  return constactList
}

function getContactDataFromSnList(ele) {
  let data = {}
  data['isSalesNavigator'] = true
  const nameHolderV1 = ele.querySelector(
    '.lists-detail__view-profile-name-link'
  )
  const nameHolderV2 = ele.querySelector(
    '.list-detail_name-and_badge div:first-child button span'
  )

  const summaryHolderV1 = ele.querySelector(
    '.horizontal-person-entity-lockup-4 dl div div'
  )
  const summaryHolderV2 = ele.querySelector(
    '.horizontal-person-entity-lockup-4 .list-detail_name-and_badge + div div'
  )

  const companyHolder = ele.querySelector('.company-entity')
  if (summaryHolderV1 || summaryHolderV2) {
    const title = summaryHolderV1
      ? summaryHolderV1.innerText
      : summaryHolderV2
      ? summaryHolderV2.innerText
      : ''
    data['title'] = trimSpacesAndNewLine(title)
    data['currentSummary'] = trimSpacesAndNewLine(title)
  }
  if (companyHolder) {
    data['companyName'] = companyHolder.innerText.trim()
    if (companyHolder.querySelector('a'))
      data['companyUrl'] = getLiCPUrl(companyHolder.querySelector('a').href)
    data['companyUrl']
      ? (data['isVerifiedDomain'] = true)
      : (data['isVerifiedDomain'] = false)
  }
  if (nameHolderV1 || nameHolderV2)
    data['fullName'] = trimSpacesAndNewLine(
      nameHolderV1
        ? nameHolderV1.innerText
        : nameHolderV2
        ? nameHolderV2.innerText.split(',')[0]
        : ''
    )
  const linkElementV2 = ele.querySelector(
    '.horizontal-person-entity-lockup-4 figure a'
  )
  let linkedinId = nameHolderV1
    ? getPathname(nameHolderV1.href) + getSearchStringFromUrl(nameHolderV1.href)
    : linkElementV2
    ? getPathname(linkElementV2.href) +
      getSearchStringFromUrl(linkElementV2.href)
    : ''

  if (linkedinId != '' && linkedinId.indexOf('www.linkedin.com') == -1) {
    linkedinId = 'https://www.linkedin.com' + linkedinId
  }
  data['linkedinId'] = linkedinId
  return data
}

function getContactDataFromSn(ele) {
  let data = {}
  data['isSalesNavigator'] = true
  const nameHolder = ele.querySelector('.result-lockup__name')
  const summaryHolder = ele.querySelector('.result-lockup__highlight-keyword')
  const companyHolder = ele.querySelector('.result-lockup__position-company')
  if (summaryHolder && companyHolder) {
    data['title'] = trimSpacesAndNewLine(summaryHolder.innerText)
      .replace(trimSpacesAndNewLine(companyHolder.innerText), '')
      .replace(' at ', '')
    data['companyName'] = companyHolder.innerText.trim().split('\n')[0]
    data['companyUrl'] = getLiCPUrl(companyHolder.querySelector('a').href)
    data['companyUrl']
      ? (data['isVerifiedDomain'] = true)
      : (data['isVerifiedDomain'] = false)
  }
  nameHolder && (data['fullName'] = trimSpacesAndNewLine(nameHolder.innerText))
  let linkedinId =
    (nameHolder &&
      getPathname(nameHolder.querySelector('a').href) +
        getSearchStringFromUrl(nameHolder.querySelector('a').href)) ||
    ''
  if (linkedinId != '' && linkedinId.indexOf('www.linkedin.com') == -1) {
    linkedinId = 'https://www.linkedin.com' + linkedinId
  }
  data['linkedinId'] = linkedinId
  summaryHolder &&
    (data['currentSummary'] = trimSpacesAndNewLine(summaryHolder.innerText))
  return data
}

function getContactDataFromSnV1(ele) {
  let data = {}
  data['isSalesNavigator'] = true
  const nameHolder = ele.querySelector('.artdeco-entity-lockup__title')
  const summaryHolder = ele.querySelector('.artdeco-entity-lockup__subtitle')

  if (summaryHolder) {
    const titleEle = summaryHolder.querySelector('span')
    if (titleEle) data['title'] = trimSpacesAndNewLine(titleEle.innerText)
  }

  const companyHolder = ele.querySelector('.artdeco-entity-lockup__subtitle a')
  if (companyHolder) {
    data['companyName'] = companyHolder.innerText.trim().split('\n')[0]
    data['companyUrl'] = getLiCPUrl(companyHolder.href)
    data['companyUrl']
      ? (data['isVerifiedDomain'] = true)
      : (data['isVerifiedDomain'] = false)
  }
  nameHolder && (data['fullName'] = trimSpacesAndNewLine(nameHolder.innerText))

  let linkedinId =
    (nameHolder &&
      getPathname(nameHolder.querySelector('a').href) +
        getSearchStringFromUrl(nameHolder.querySelector('a').href)) ||
    ''
  if (linkedinId != '' && linkedinId.indexOf('www.linkedin.com') == -1) {
    linkedinId = 'https://www.linkedin.com' + linkedinId
  }
  data['linkedinId'] = linkedinId
  summaryHolder &&
    (data['currentSummary'] = trimSpacesAndNewLine(summaryHolder.innerText))
  return data
}

function hasValidCompanyPage(url) {
  return url.indexOf('/search') == -1
}

function getLiCPUrl(url) {
  if (url && hasValidCompanyPage(url)) {
    const elements = getPathname(url).split('/')
    const companyId = elements[elements.length - 1]
    return 'linkedin.com/company/' + companyId + '/'
  }
}

function getContactData(ele, bulkParserType) {
  if (bulkParserType == 'v1') {
    let data = {}
    const nameHolder = ele.querySelector('.actor-name')
    const summaryHolder = ele.querySelector('.subline-level-1')
    const addressHolder = ele.querySelector('.subline-level-2')
    const otherSummaryHolder = ele.querySelector('.search-result__snippets')
    const linkedinIdHolder = ele.querySelector('a')
    if (!nameHolder) {
      return null
    }

    nameHolder &&
      (data['fullName'] = trimSpacesAndNewLine(nameHolder.innerText))
    summaryHolder &&
      (data['summary'] = trimSpacesAndNewLine(summaryHolder.innerText))
    addressHolder &&
      (data['address'] = trimSpacesAndNewLine(addressHolder.innerText))
    let currentCompany = getPathname(linkedinIdHolder.href)
    if (currentCompany.indexOf('www.linkedin.com') == -1) {
      currentCompany = 'https://www.linkedin.com' + currentCompany
    }

    linkedinIdHolder && (data['linkedinId'] = currentCompany)
    if (otherSummaryHolder) {
      if (otherSummaryHolder.innerText.toLowerCase().indexOf('past:') != -1) {
        data['pastSummary'] = trimSpacesAndNewLine(
          otherSummaryHolder.innerText
        ).replace('Past:', '')
      } else if (
        otherSummaryHolder.innerText.toLowerCase().indexOf('current:') != -1
      ) {
        data['currentSummary'] = trimSpacesAndNewLine(
          otherSummaryHolder.innerText
        ).replace('Current:', '')
      }
    }
    return data
  } else {
    let data = {}
    const nameHolder = ele.querySelector('.entity-result__title-text a')
    const summaryHolder = ele.querySelector('.entity-result__primary-subtitle')
    const addressHolder = ele.querySelector(
      '.entity-result__secondary-subtitle'
    )
    const linkedinIdHolder = ele.querySelector('a')

    let nameStr =
      nameHolder && nameHolder.innerText ? nameHolder.innerText.trim() : ''
    const nameHiddenEle = ele.querySelector(
      '.entity-result__title-text a .visually-hidden'
    )
    const nameHiddenTxt = nameHiddenEle ? nameHiddenEle.innerText.trim() : ''

    if (nameHiddenTxt != '') {
      nameStr = nameStr.replace(nameHiddenTxt, '')
    }

    if (!nameHolder || nameStr == '') {
      return null
    }
    nameStr && (data['fullName'] = trimSpacesAndNewLine(nameStr))
    summaryHolder &&
      (data['summary'] = trimSpacesAndNewLine(summaryHolder.innerText))
    addressHolder &&
      (data['address'] = trimSpacesAndNewLine(addressHolder.innerText))
    let currentCompany = getPathname(linkedinIdHolder.href)
    if (currentCompany.indexOf('www.linkedin.com') == -1) {
      currentCompany = 'https://www.linkedin.com' + currentCompany
    }

    linkedinIdHolder && (data['linkedinId'] = currentCompany)
    return data
  }
}
/* Bulk Parser Ends */

export const checkIsPresentTextMatch = (text, language) => {
  let presentText = 'present'
  const selectedLanguage =
    language !== undefined ? language : LI_CHOOSEN_LANGUAGE

  if (selectedLanguage !== '') {
    if (
      LI_LANGUAGE_MAP[selectedLanguage] !== undefined &&
      LI_LANGUAGE_MAP[selectedLanguage].presentText !== undefined
    ) {
      presentText = LI_LANGUAGE_MAP[selectedLanguage].presentText.toLowerCase()
    }
  }

  return text.toLowerCase().indexOf(presentText) != -1
}

export const LI_LANGUAGE_MAP = {
  ar_AE: {
    languageName: 'العربية (Arabic)',
    presentText: 'الحالي'
  },
  cs_CZ: {
    languageName: 'Čeština (Czech)',
    presentText: 'do současnosti'
  },
  da_DK: {
    languageName: 'Dansk (Danish)',
    presentText: 'nu'
  },
  de_DE: {
    languageName: 'Deutsch (German)',
    presentText: 'Heute'
  },
  en_US: {
    languageName: 'English (English)',
    presentText: 'present'
  },
  es_ES: {
    languageName: 'Español (Spanish)',
    presentText: 'actualidad'
  },
  fr_FR: {
    languageName: 'Français (French)',
    presentText: 'Aujourd’hui'
  },
  in_ID: {
    languageName: 'Bahasa Indonesia (Bahasa Indonesia)',
    presentText: 'Saat ini'
  },
  it_IT: {
    languageName: 'Italiano (Italian)',
    presentText: 'presente'
  },
  ja_JP: {
    languageName: '日本語 (Japanese)',
    presentText: '現在'
  },
  ko_KR: {
    languageName: '한국어 (Korean)',
    presentText: '현재'
  },
  ms_MY: {
    languageName: 'Bahasa Malaysia (Malay)',
    presentText: 'Kini'
  },
  nl_NL: {
    languageName: 'Nederlands (Dutch)',
    presentText: 'heden'
  },
  no_NO: {
    languageName: 'Norsk (Norwegian)',
    presentText: 'nå'
  },
  pl_PL: {
    languageName: 'Polski (Polish)',
    presentText: 'obecnie'
  },
  pt_BR: {
    languageName: 'Português (Portuguese)',
    presentText: 'o momento'
  },
  ro_RO: {
    languageName: 'Română (Romanian)',
    presentText: 'Prezent'
  },
  ru_RU: {
    languageName: 'Русский (Russian)',
    presentText: 'настоящее время'
  },
  sv_SE: {
    languageName: 'Svenska (Swedish)',
    presentText: 'nu'
  },
  th_TH: {
    languageName: 'ภาษาไทย (Thai)',
    presentText: 'ปัจจุบัน'
  },
  tl_PH: {
    languageName: 'Tagalog (Tagalog)',
    presentText: 'Kasalukuyan'
  },
  tr_TR: {
    languageName: 'Türkçe (Turkish)',
    presentText: 'Şu Anda'
  },
  zh_CN: {
    languageName: '简体中文 (Chinese (Simplified))',
    presentText: '至今'
  },
  zh_TW: {
    languageName: '正體中文 (Chinese (Traditional))',
    presentText: '目前'
  }
}
